import { render, staticRenderFns } from "./kycApproveDetails.vue?vue&type=template&id=45981aa4&scoped=true&"
import script from "./kycApproveDetails.vue?vue&type=script&lang=js&"
export * from "./kycApproveDetails.vue?vue&type=script&lang=js&"
import style0 from "./kycApproveDetails.vue?vue&type=style&index=0&id=45981aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45981aa4",
  null
  
)

export default component.exports